export { default } from './CurrentWaterTemperatures';
